import type { RefundAccountInput } from './paymentSchema';

/**
 * 클레임 상세의 고객 환불 계좌(be-order a7dd5f8, ClaimDetailResponse.refundAccount) → 환불 모달 초기값.
 *
 *   refundAccount: { bankCode, bankName, accountNumber, accountHolderName, masked } | null
 *
 * 관리자 응답은 원문(masked=false)이다. 가려진 값(masked=true)이거나 비어 있으면 채우지 않는다 — "****" 를 계좌로
 * 보내면 Toss 송금이 실패한다. generated 타입에 아직 없어 로컬 타입으로 읽는다.
 */
interface ClaimRefundAccountView {
  bankCode?: string | null;
  bankName?: string | null;
  accountNumber?: string | null;
  accountHolderName?: string | null;
  masked?: boolean | null;
}

export const claimRefundAccountPrefill = (claim: unknown): RefundAccountInput | null => {
  const account = (claim as { refundAccount?: ClaimRefundAccountView | null } | null | undefined)?.refundAccount;
  if (!account || account.masked) return null;
  const bankCode = account.bankCode?.trim() ?? '';
  const accountNumber = account.accountNumber?.trim() ?? '';
  const holderName = account.accountHolderName?.trim() ?? '';
  if (!bankCode && !accountNumber && !holderName) return null;
  return { bankCode, accountNumber, holderName };
};
